import VerticalSpacer from './VerticalSpacer';

export default VerticalSpacer;
